import { withAPIAccount } from '../../lib/http/api';
import { parsedResponse } from '../../lib/http/http';
import { AccountType, IAPIresponse } from '../../model';
import { IApiOrderListItem } from '../../model/api-modules';
import {
  IDrawCheckBody,
  IDrawHistoryItem,
  ISetFreezeBody,
} from '../../model/billing-center/withdrawal';
import { assignStudioQuery } from '../billing-center';
import { ADMIN_BILLING_PROXY } from '../config';

// 提现记录-列表----admin侧
export const getAdminDrawHistoryList = (studioId?: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${ADMIN_BILLING_PROXY}/api/account/draw_history`
      );
      const response = await api.commonRequest('GET', url, {
        studio_id: studioId,
        page: 1,
        size: 9999,
      });
      const res = await parsedResponse<IDrawHistoryItem>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: getAdminDrawHistoryList', error);
      return null;
    }
  });
// 提现审核----admin侧
export const putDrawMoneyCheck = (body: IDrawCheckBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${ADMIN_BILLING_PROXY}/api/account/draw_check`
      );
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: putDrawMoneyCheck', error);
      return null;
    }
  });

export const getAdminOrderList = (query: {
  studio_id: string;
  service_id: Number;
  env_id: Number;
}) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(`${ADMIN_BILLING_PROXY}/api/order/list`);
      const response = await api.commonRequest('GET', url, {
        ...query,
        page: 1,
        size: 99999,
      });
      const res = await parsedResponse<{
        readonly list: ReadonlyArray<IApiOrderListItem>;
      }>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: editFreezeAmount', error);
      return null;
    }
  });

export const editFreezeAmount = (body: ISetFreezeBody) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = assignStudioQuery(
        `${ADMIN_BILLING_PROXY}/api/order/freeze_set`
      );
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<IAPIresponse>(response, 'data');
      return res;
    } catch (error) {
      console.log('failed: editFreezeAmount', error);
      return null;
    }
  });
